module.exports = __webpack_public_path__ + "img/box-icon.e3c9782.svg";